export default __webpack_public_path__ + "static/media/scanrobo.df15263a.png";